  <template>
  <div>
    <van-nav-bar
      title="持仓列表"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/stable_coinbao')"

    />
    <!-- <div class="">
      <van-row style="padding-top: 10px;"
        ><van-col span="3" class="rowStyle" style="text-align: center"
          ><span style="font-size: 13px">日期:</span></van-col
        >
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="startDate"
              @click="startStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="startStatus" position="bottom">
              <van-datetime-picker
                style="color: red"
                v-model="date"
                @confirm="onConfirmStartDate"
                @cancel="startStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="2" class="rowStyle" style="text-align: center"
          ><span>--</span></van-col
        >
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="endDate"
              @click="endStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="endStatus" position="bottom">
              <van-datetime-picker
                v-model="date"
                @confirm="onConfirmEndDate"
                @cancel="endStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="5" class="rowStyleBtn" style="text-align: center"
          ><van-button
            type="danger"
            size="small"
            style="height: 30px; background-color: unset; color: #0D268D"
            @click="onSearchButton"
            >检索</van-button
          ></van-col
        >
      </van-row>
    </div> -->

    <div class="tableDetails">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="isLoading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadMore"
          offset:50
          immediate-check:false
        >

        <van-row>
            <van-col span="6" style="text-align: center; font-weight: bold;">
              <span>产品/状态</span>
            </van-col>
            <van-col span="6" style="text-align: center; font-weight: bold;">
              <span>金额/收益</span>
            </van-col>

            <van-col span="6" style="text-align: center; font-weight: bold;">
              <span>创建时间/到期时间</span>
            </van-col>
            
            <van-col span="6" style="text-align: center; font-weight: bold;">
              <span>操作</span>
            </van-col>
          </van-row>
           <van-row
            v-for="(item, index) in userProudctLists"
            :key="index"
          >
          <hr></hr>
            <van-col span="6">
              <div >
                <p style="text-align: center;">{{ item.name }}</p>
                 <p style="text-align: center;margin-top: -10px;">
              <span v-if="item.status ==0" style="color:grey;">
                等待到期
              </span>
               <span v-else-if="item.status ==1" style="color:#3F7A21;">
                已到期
              </span>
              <span v-else style="color:#ED7D31">已赎回</span>
              </p>
              </div>
            </van-col>
            <van-col span="6">
              <div style="text-align: center;">
                <p>{{ item.amount }}</p>
                <p style="margin-top:-10px;">{{ item.interest_amount }}</p>
              </div>
            </van-col>

            <van-col span="6">
              <div style="text-align: center;">
                <p>
                  {{item.create_time}}
                </p>
                <p style="margin-top:-10px;">{{ item.expire_time }}</p>
              </div>
            </van-col>
            <van-col span="6" v-if="item.status==0">
              <div style="text-align: center;">
                 <p>
              <van-button
           type="info"
           size="small"
           @click="cancelOrderShowPopup(item)"
           plain
           style="
           border-radius: 8px;
            background-color: #D02E27;border:#D02E27;color:white;margin-left: 5px;"
           
           >提前赎回
         </van-button> 
        </p>   
              </div>
            </van-col>
          </van-row>
        
         
          
          <div style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;">
          只显示最近12个月记录
        </div>
        </van-list>
      </van-pull-refresh>
       <!-- ==================== cancel order popup ========================== -->

    <van-dialog
      v-model="cancelOrderState"
      title="提前赎回"
      show-cancel-button
      :beforeClose="cancelOrder"
    >
    <div>
    <van-row style="padding-left: 15px;font-size:14px">
      <van-col span="2">&nbsp;</van-col>
        <van-col span="20">
         <h4>您申购的基金到期还剩下 {{ expire_duration }}，提前赎回不享受收益，您确定要赎回吗？</h4></van-col>
               <van-col span="2">&nbsp;</van-col>
      </van-row>
    </div>
    </van-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "StableCoinbaoUserProductList",
  data() {
    return {
      date: new Date(),
      isLoading: false,
      userProudctLists: [],
      finished: false,
      refreshing: false,
      page: 0,
      num: 20,
      cancelOrderState:false,
      cancelOrderId:null,
       expire_duration:null,
        timerInterval:null
    };
  },
  computed: {},
  methods: {
     cancelation(){
          this.cancelOrderState=false;
          this.stopTimer();
        },
        ExpireTimer(productDetail){
          let now = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Shanghai" }));        
        let expire = new Date(productDetail.expire_time.replace(/\./g, "-"));
        this.expire_duration=null;
        if (productDetail.status == 0 && expire >= now) {
          let diff = Math.floor((expire - now) / 1000); 
            if(diff<0){
          this.expire_duration=null;
            this.stopTimer();
            }else{
              let days = Math.floor(diff / 86400);
            let hours = Math.floor(diff % 86400 / 3600);
            let minutes = Math.floor(diff % 3600 / 60);
            let seconds = diff % 60;
            this.expire_duration = `${days ? days + " 天 " : ""}${hours ? hours + " 小时 " : ""}${minutes ? minutes + " 分 " : ""}${seconds ? seconds + " 秒" : ""}`;
      
            }
             }
        else{
          this.expire_duration=null;
          this.stopTimer();
        }
      },
 cancelOrder(action, done) {
      let that = this;
      switch (action) {
        case "confirm":
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "stable_coinbao_fund",
                  token: sessionStorage.getItem("token"),
                    action: 'cancel_order',
                  product_detail_id:that.cancelOrderId,
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$toast({
                    message: res.data.msg,
                    type: "success",
                    onClose: function () {
                    let product = that.userProudctLists.find(
                      (p) => p.id === that.cancelOrderId
                    );
                    if (product) {
                      product.status = 2; 
                      }
                      that.stopTimer();
                      that.getUserProductLists();
                        that.cancelOrderState = false;
                      done();
                    },
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                    that.stopTimer();
                  that.$toast.fail(res.data.msg);
                  done(false);
                }
              });
          
          break;
        case "cancel":
          that.stopTimer();
          done();
          break;
      }
    },
     cancelOrderShowPopup(productDetail){
      let that=this;
          this.cancelOrderState=true;
          this.cancelOrderId=productDetail.id;
           if (this.timerInterval) clearInterval(this.timerInterval);
        that.ExpireTimer(productDetail);
      this.timerInterval = setInterval(() => {
        that.ExpireTimer(productDetail);
      }, 1000);
        },
    onSearchButton(){
      this.page=0;
      this.userProudctLists=[];
      this.finished=false;
      this.loadMore();
    },
    loadMore() {
      // console.log("here");
      this.isLoading = true;
      this.page++;
      this.getUserProductLists();
    },
    onRefresh() {
      this.userProudctLists = [];
      this.finished = false;
      this.page=0;
      this.refreshing = true;
      this.getUserProductLists();
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getUserProductLists() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stable_coinbao_fund",
            token: sessionStorage.getItem("token"),
            action: "user_product_list",
            page: that.page,
            num: that.num,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            // that.userProudctLists=resData.data;
            if (resData.data.length === 0) {
              that.finished = true;
            } else {
              resData.data.forEach((element) => {
                that.userProudctLists.push(element);
              });
              console.log("user",that.userProudctLists);
            }
            that.refreshing = false;
            that.isLoading = false;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.refreshing = false;
          that.isLoading = false;
          that.finished = true;
        });
    },
  stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
      },
    },
  beforeDestroy() {
    this.stopTimer();

},
  mounted() {},
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.topContent {
  height: 50px;
  background: #ffffff;
  position: fixed;
  top: 42px;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.dateFilter {
  padding: 0px 5px;
  position: fixed;
  top: 56px;
  left: 0;
  width: 100%;
  /* border-bottom: 1px solid #ebedf0; */
  padding-bottom: 10px;
}

.rowStyle {
  height: 30px;
  line-height: 30px;
}

.calanderStyle {
  border: 1px solid #969799;
}

.rowStyleBtn {
  line-height: 20px;
}

.tableDetails {
  margin-top: 10px;
  font-size: 14px;
  padding: 0px 10px;
}

.rowDesign {
  text-align: center;
  line-height: 10px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgb(200, 201, 204);
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/StableCoinbaoUserProductList.vue